<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/promotion-tools/cms/widgets'">Widgets</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      <span class="fs-5 fw-bold mb-0">Add Widget</span>
    </li>
  </ol>
</nav>

@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row g-3 mb-3">
          <div class="col">
            <label class="form-label">Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi bi-tag"></i></span>
              <input type="text" class="form-control" placeholder="Name" formControlName="name">
            </div>
          </div>
          <div class="col">
            <label for="site" class="form-label">Site</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-box"></i></span>
              <select id="site" class="form-select" formControlName="siteId">
                <option [ngValue]="null" disabled>Select site</option>
                @for (site of sites; track site) {
                  <option [ngValue]="site.id">{{ site }}</option>
                }
              </select>
            </div>
          </div>
          <div class="col">
            <label for="productPriority" class="form-label">Arbitrage</label>
            <app-product-priority-selector id="productPriority" formControlName="productPriority"
                                           [selectMode]="true"></app-product-priority-selector>
          </div>
          <div class="col">
            <label for="site" class="form-label">Access rights</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-lock"></i></span>
              <select id="site" class="form-select" formControlName="scope">
                <option value="public">Public</option>
                <option value="private">Private</option>
                <option value="protected">Protected</option>
              </select>
            </div>
          </div>
        </div>
        <!-- Old design
        <div class="row">
          <label class="form-label">Widget</label>
          <div class="col d-flex text-center">
            <label class="widget-old" *ngFor="let widget of widgetList">
              <span class="widget-old-name">{{ widget.name }}</span>
              <span class="widget-old-description">{{ widget.description }}</span>
              <input class="form-check-input" type="radio" [id]="widget.identifier"
                [value]="widget.identifier" formControlName="type">
            </label>
          </div>
        </div>
        -->
        <div class="row">
          <label class="form-label">Widget type</label>
          <div class="col">
            <div class="widget-grid">
              @for (widget of widgetList; track widget) {
                <label class="widget-card"
                       [class.widget-card-selected]="form.get('type')?.value === widget.identifier">
                  <input class="visually-hidden" type="radio" [id]="widget.identifier"
                         [value]="widget.identifier" formControlName="type">
                  <div class="widget-card-icon">
                    <i class="bi" [ngClass]="{
                  'bi-stars': widget.identifier === 'horoscope-form',
                  'bi-suit-spade-fill': widget.identifier === 'tarot-form',
                  'bi-list-columns-reverse': widget.identifier === 'multistep-form',
                  'bi-calendar-heart': widget.identifier === 'multistep-birth-form',
                  'bi-file-earmark-text': widget.identifier === 'onepage-form',
                  'bi-layout-text-sidebar-reverse': widget.identifier === 'compact-form',
                  'bi-shuffle': widget.identifier === 'xsell',
                  'bi-eye': widget.identifier === 'selection',
                  'bi-check-circle-fill': widget.identifier === 'confirmation',
                }"></i>
                  </div>
                  <div class="widget-card-name">{{ widget.name }}</div>
                  <div class="widget-card-description">{{ widget.description }}</div>
                  <div class="widget-card-check">
                    <i class="bi bi-check-circle-fill"></i>
                  </div>
                </label>
              }
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col text-end">
            <button type="submit" class="btn btn-primary fw-bold">
              <span>Create</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
